import { useState, useEffect } from 'react';
import './Jumble.css';
import SEO from '../../SEO/SEO';
// Game data (20 words per level)
const levelData = {
  beginner: [
    { word: "RAIN", hint: "Water falling from clouds", jumbled: "IARN" },
    { word: "BOOK", hint: "Collection of pages with text", jumbled: "OBOK" },
    { word: "TREE", hint: "Tall plant with trunk and branches", jumbled: "ERET" },
    { word: "FISH", hint: "Aquatic animal with fins", jumbled: "IFSH" },
    { word: "STAR", hint: "Bright object in the night sky", jumbled: "TRAS" },
    { word: "LAMP", hint: "Device that produces light", jumbled: "PMAL" },
    { word: "CAKE", hint: "Sweet baked dessert", jumbled: "EKCA" },
    { word: "FROG", hint: "Green jumping amphibian", jumbled: "GROF" },
    { word: "SOUP", hint: "Liquid food served hot in a bowl", jumbled: "UPSO" },
    { word: "BALL", hint: "Round object used in sports", jumbled: "LABL" },
    { word: "MILK", hint: "White drink from cows", jumbled: "KLIM" },
    { word: "MOON", hint: "Earth's natural satellite", jumbled: "ONOM" },
    { word: "WIND", hint: "Air in motion", jumbled: "DNWI" },
    { word: "DUCK", hint: "Water bird that quacks", jumbled: "CKUD" },
    { word: "GOAT", hint: "Farm animal with horns", jumbled: "TAGO" },
    { word: "HAND", hint: "Part of the body used to hold", jumbled: "ADNH" },
    { word: "SOAP", hint: "Used for washing", jumbled: "OSPA" },
    { word: "BELL", hint: "Rings to make sound", jumbled: "ELBL" },
    { word: "ROCK", hint: "Hard solid mineral material", jumbled: "CORK" },
    { word: "DOOR", hint: "Entry to a room", jumbled: "ODOR" }
  ],
  intermediate: [
    { word: "APPLE", hint: "Red or green fruit", jumbled: "PLEAP" },
    { word: "CLOUD", hint: "White fluffy formation in the sky", jumbled: "DLCUO" },
    { word: "BREAD", hint: "Baked food made from flour", jumbled: "DABRE" },
    { word: "TIGER", hint: "Large striped wildcat", jumbled: "GIETR" },
    { word: "WATER", hint: "Clear liquid essential for life", jumbled: "TERAW" },
    { word: "MONEY", hint: "Currency used for transactions", jumbled: "ENMOY" },
    { word: "PHONE", hint: "Device used for communication", jumbled: "NEPHO" },
    { word: "HOUSE", hint: "Building for human habitation", jumbled: "SUOEH" },
    { word: "MUSIC", hint: "Pleasing sounds arranged rhythmically", jumbled: "ISCMU" },
    { word: "BEACH", hint: "Sandy shore by the ocean", jumbled: "EACBH" },
    { word: "FRUIT", hint: "Sweet food from a plant", jumbled: "TRUIF" },
    { word: "PLANE", hint: "Aircraft that flies", jumbled: "NEALP" },
    { word: "CHESS", hint: "Strategic board game", jumbled: "SECHS" },
    { word: "SUGAR", hint: "Sweet substance", jumbled: "ARSGU" },
    { word: "GHOST", hint: "Supernatural being", jumbled: "STHOG" },
    { word: "NURSE", hint: "Healthcare assistant", jumbled: "SENUR" },
    { word: "CANDY", hint: "Sweet treat", jumbled: "YDANC" },
    { word: "CYCLE", hint: "Two-wheeled vehicle", jumbled: "CLECY" },
    { word: "TRAIN", hint: "Runs on tracks", jumbled: "NRATI" },
    { word: "ZEBRA", hint: "Striped animal", jumbled: "BAZER" }
  ],
  advanced: [
    { word: "GUITAR", hint: "Stringed musical instrument", jumbled: "UTGIAR" },
    { word: "CAMERA", hint: "Device to capture photos", jumbled: "AARMCE" },
    { word: "PLANET", hint: "Celestial body orbiting a star", jumbled: "NLEPAT" },
    { word: "GARDEN", hint: "Area where plants are grown", jumbled: "RAEGND" },
    { word: "DOCTOR", hint: "Medical professional", jumbled: "TOCROD" },
    { word: "COFFEE", hint: "Popular caffeinated beverage", jumbled: "EEFFOC" },
    { word: "JUNGLE", hint: "Dense tropical forest", jumbled: "GLENJU" },
    { word: "PUZZLE", hint: "Game that tests ingenuity", jumbled: "ZELZPU" },
    { word: "DESIGN", hint: "Plan or drawing showing layout", jumbled: "SDEIGN" },
    { word: "OXYGEN", hint: "Element essential for breathing", jumbled: "GEXNOY" },
    { word: "PYTHON", hint: "Programming language", jumbled: "NYPTOH" },
    { word: "WINDOW", hint: "Opening in a wall", jumbled: "NODWIW" },
    { word: "MARKET", hint: "Place to buy goods", jumbled: "TEKMAR" },
    { word: "BUTTON", hint: "Used to fasten clothes", jumbled: "TUBTON" },
    { word: "FOLDER", hint: "Used to store files", jumbled: "LERFOD" },
    { word: "BRIDGE", hint: "Structure over water", jumbled: "GIRDEB" },
    { word: "SCHOOL", hint: "Place for education", jumbled: "CHOSLO" },
    { word: "PEOPLE", hint: "Group of humans", jumbled: "LOPEEP" },
    { word: "MIRROR", hint: "Reflects images", jumbled: "RIRROM" },
    { word: "ACTION", hint: "Movement or deed", jumbled: "NTOACI" }
  ]
};

// Utility: Shuffle array
const shuffleArray = (arr) => {
  return arr.sort(() => 0.5 - Math.random());
};

export default function JumbleWordGame() {
  const [level, setLevel] = useState('beginner');
  const [gameStarted, setGameStarted] = useState(false);
  const [currentLevelWords, setCurrentLevelWords] = useState([]);
  const [currentLevelIndex, setCurrentLevelIndex] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [score, setScore] = useState(0);
  const [timer, setTimer] = useState(60);
  const [showMenu, setShowMenu] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [isCorrect, setIsCorrect] = useState(null);

  const currentPuzzle = gameStarted ? currentLevelWords[currentLevelIndex] : null;

  useEffect(() => {
    let interval;
    if (gameStarted && !gameOver && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setGameOver(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [gameStarted, gameOver, timer]);

  const startGame = (selectedLevel) => {
    const randomWords = shuffleArray([...levelData[selectedLevel]]).slice(0, 5);
    setLevel(selectedLevel);
    setCurrentLevelWords(randomWords);
    setCurrentLevelIndex(0);
    setScore(0);
    setTimer(60);
    setGameStarted(true);
    setGameOver(false);
    setShowMenu(false);
    setUserAnswer('');
    setIsCorrect(null);
  };

  const checkAnswer = () => {
    if (userAnswer.toUpperCase() === currentPuzzle.word) {
      setScore(score + 10);
      setIsCorrect(true);
      setTimeout(() => {
        nextWord();
        setIsCorrect(null);
      }, 800);
    } else {
      setIsCorrect(false);
    }
  };

  const nextWord = () => {
    if (currentLevelIndex < currentLevelWords.length - 1) {
      setCurrentLevelIndex(currentLevelIndex + 1);
      setUserAnswer('');
    } else {
      setGameOver(true);
    }
  };

  const handleInputChange = (e) => setUserAnswer(e.target.value);
  const resumeGame = () => setShowMenu(false);
  const changeLevel = () => { setGameStarted(false); setShowMenu(false); };
  const quitGame = () => { setGameStarted(false); setShowMenu(false); };

  return (
    <div className="jumble-game-container">
      <SEO
  title="Jumble Word Game | Boldly English"
  description="Improve your English vocabulary with a fun Jumble Word Game featuring beginner, intermediate, and advanced word puzzles."
canonical="https://boldlyenglish.com/jumbleWordGame"
/>
      {!gameStarted ? (
        // Level selection screen
        <div className="jumble-level-selection">
          <h1 className="jumble-game-title">JUMBLE WORD</h1>
          <h2 className="jumble-level-heading">Select Stages</h2>
          <div className="jumble-level-buttons">
            <button 
              onClick={() => startGame('beginner')}
              className="jumble-btn btn-beginner"

            >
              Beginner
            </button>
            <button 
              onClick={() => startGame('intermediate')}
              className="jumble-btn btn-intermediate"
            >
              Intermediate
            </button>
            <button 
              onClick={() => startGame('advanced')}
              className="jumble-btn btn-advanced"
            >
              Advanced
            </button>
          </div>
        </div>
      ) : (
        // Game screen
        <div className="jumble-game-screen">
          {/* Menu overlay */}
          {showMenu && (
            <div className="jumble-menu-overlay">
              <div className="jumble-menu-container">
                <h2 className="jumble-menu-title">Menu</h2>
                <div className="jumble-menu-buttons">
                  <button 
                    onClick={resumeGame}
                    className="btn btn-resume"
                  >
                    Resume Game
                  </button>
                  <button 
                    onClick={changeLevel}
                    className="btn btn-change-level"
                  >
                    Change Level
                  </button>
                  <button 
                    onClick={quitGame}
                    className="btn btn-quit"
                  >
                    Quit Game
                  </button>
                </div>
              </div>
            </div>
          )}
          
          {/* Game over overlay */}
          {gameOver && (
            <div className="jumble-game-over-overlay">
              <div className="jumble-game-over-container">
                <h2 className="jumble-game-over-title">Game Over!</h2>
                <p className="jumble-game-over-score">Your Score: {score}</p>
                <div className="jumble-game-over-buttons">
                  <button 
                    onClick={() => startGame(level)}
                    className="jumble-btn jumble-btn-play-again"
                  >
                    Play Again
                  </button>
                  <button 
                    onClick={changeLevel}
                    className="jumble-btn jumble-btn-change-level"
                  >
                    Change Level
                  </button>
                </div>
              </div>
            </div>
          )}
          
          {/* Game interface */}
          <div className="jumble-game-interface">
            {/* Header with level, time and score */}
            <div className="jumble-game-header">
              <div className="jumble-level-indicator">
                <span className="jumble-level-text">{level}</span>
              </div>
              <button 
                onClick={() => setShowMenu(true)}
                className="jumble-menu-button"
              >
                Menu
              </button>
              <div className="jumble-timer-indicator">
                <span className="jumble-timer-text">Time: {timer}s</span>
              </div>
              <div className="jumble-score-indicator">
                <span className="jumble-score-text">Score: {score}</span>
              </div>
            </div>
            
            {/* Progress indicator */}
            <div className="jumble-progress-bar-container">
              <div 
                className="jumble-progress-bar"
                style={{ width: `${(currentLevelIndex / levelData[level].length) * 100}%` }}
              ></div>
            </div>
            
            {/* Hint */}
            <div className="jumble-hint-container">
              <h2 className="jumble-hint-title">Hint:</h2>
              <p className="jumble-hint-text">{currentPuzzle.hint}</p>
            </div>
            
            {/* Jumbled word */}
            <div className="jumble-jumbled-container">
              <h2 className="jumble-jumbled-title">Jumbled Word:</h2>
              <p className="jumble-jumbled-text">{currentPuzzle.jumbled}</p>
            </div>
            
            {/* Answer input */}
            <div className="jumble-answer-container">
              <h2 className="jumble-answer-title">Your Answer:</h2>
              <div className="jumble-answer-input-group">
                <input
                  type="text"
                  value={userAnswer}
                  onChange={handleInputChange}
                  className={`jumble-answer-input ${
                    isCorrect === true ? 'correct' : 
                    isCorrect === false ? 'incorrect' : ''
                  }`}
                  placeholder="Type your answer"
                />
                <button
                  onClick={checkAnswer}
                  className="jumble-btn jumble-btn-check"
                >
                  Check
                </button>
              </div>
            </div>
            
            {/* Next word button */}
            <div className="jumble-next-word-container">
              <button
                onClick={nextWord}
                className="jumble-btn jumble-btn-next"
              >
                Next Word
              </button>
            </div>
          </div>
          
        </div>
        
      )}
    </div>
  );
}